import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import BaseChartCard from '../base-chart-card';
import TimeOnQuestion from '../time-on-question';
import { ItemIcon } from './styles';
import Divider from '../../../../../../../core/layout-components/divider';

const VideoChart = (props) => {
  const {
    title, data, projectId,
  } = props;

  const {
    id,
    label,
    questionOrder,
    writtenAndTranscriptAnswers,
    videoUrl,
    averageTime,
  } = data;

  const [questionText, setQuestionText] = useState('');

  useEffect(() => {
    setQuestionText(
      <label aria-label={`Label for ${label}`}>
        {`${label} `}
        <a href={videoUrl} target="_blank" rel="noopener noreferrer" aria-label="Item Icon">
          <ItemIcon name="external" link />
        </a>
      </label>,
    );
  }, [label, videoUrl]);

  return (
    <BaseChartCard
      questionTitle={`Question ${questionOrder + 1}`}
      questionLabel={questionText}
      questionType={title}
      questionId={id}
    >
      <Divider />
      {!_.isEmpty(writtenAndTranscriptAnswers) && (
        <TimeOnQuestion
          data={writtenAndTranscriptAnswers}
          projectId={projectId}
          averageTime={averageTime}
        />
      )}

    </BaseChartCard>
  );
};

VideoChart.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.shape({
    label: PropTypes.string,
    id: PropTypes.string,
    questionOrder: PropTypes.number,
    writtenAndTranscriptAnswers: PropTypes.arrayOf(PropTypes.shape),
    videoUrl: PropTypes.string,
    averageTime: PropTypes.string,
  }).isRequired,
  projectId: PropTypes.string.isRequired,
};

export default VideoChart;
